import { Outlet } from 'react-router-dom'
import { useState } from 'react'
import Sidebar from './Sidebar'
import Topbar from './Topbar'
import BackgroundGradient from './BackgroundGradient'
import ChangePasswordModal from '../components/ChangePasswordModal'
import { useAuth } from '../contexts/AuthContext'

export default function AppLayout() {
  const auth = useAuth()
  const [changeOpen, setChangeOpen] = useState(false)

  const mustChange = auth.status === 'authenticated' && auth.user.mustChangePassword

  return (
    <div className="min-h-screen font-heebo flex transition-colors duration-300 relative overflow-hidden t-primary">
      <BackgroundGradient />
      <Sidebar />
      <div className="relative z-10 flex-1 flex flex-col min-w-0">
        <Topbar onChangePassword={() => setChangeOpen(true)} />
        <main className="flex-1 px-8 py-8 overflow-x-hidden">
          <Outlet />
        </main>
      </div>
      {(mustChange || changeOpen) && (
        <ChangePasswordModal
          forced={mustChange}
          onClose={mustChange ? undefined : () => setChangeOpen(false)}
        />
      )}
    </div>
  )
}
